var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57284 7.5H17.4278C17.5431 7.49995 17.6572 7.52382 17.7628 7.57011C17.8684 7.6164 17.9632 7.6841 18.0413 7.76892C18.1194 7.85375 18.179 7.95385 18.2165 8.06291C18.2539 8.17197 18.2682 8.2876 18.2587 8.4025L17.5637 16.7358C17.5463 16.9441 17.4514 17.1382 17.2977 17.2797C17.1439 17.4213 16.9426 17.4999 16.7337 17.5H3.26701C3.05805 17.4999 2.85676 17.4213 2.70303 17.2797C2.5493 17.1382 2.45436 16.9441 2.43701 16.7358L1.74201 8.4025C1.73244 8.2876 1.74682 8.17197 1.78423 8.06291C1.82165 7.95385 1.88128 7.85375 1.95937 7.76892C2.03746 7.6841 2.1323 7.6164 2.2379 7.57011C2.3435 7.52382 2.45755 7.49995 2.57284 7.5ZM4.03368 15.8333H15.967L16.522 9.16667H3.47868L4.03368 15.8333ZM11.1787 4.16667H16.667C16.888 4.16667 17.1 4.25446 17.2563 4.41074C17.4125 4.56702 17.5003 4.77899 17.5003 5V5.83333H2.50034V3.33333C2.50034 3.11232 2.58814 2.90036 2.74442 2.74408C2.9007 2.5878 3.11266 2.5 3.33368 2.5H9.51201L11.1787 4.16667Z",
    fill: "#0024A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFolder);
export default __webpack_public_path__ + "static/media/blue-folder.66dd73b339979a1156abfb5d01cd8eae.svg";
export { ForwardRef as ReactComponent };